"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["name"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Name = /*#__PURE__*/function (_React$PureComponent) {
  function Name() {
    (0, _classCallCheck2["default"])(this, Name);
    return _callSuper(this, Name, arguments);
  }
  (0, _inherits2["default"])(Name, _React$PureComponent);
  return (0, _createClass2["default"])(Name, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        name = _this$props.name,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(StyledName, (0, _extends2["default"])({
        title: name
      }, props), name);
    }
  }]);
}(_react["default"].PureComponent);
Name.propTypes = {
  className: _propTypes["default"].string,
  name: _propTypes["default"].string.isRequired
};
Name.defaultProps = {
  className: ''
};
var StyledName = _styledComponents["default"].div.withConfig({
  displayName: "Name__StyledName",
  componentId: "sc-1835vpz-0"
})(["font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var _default = exports["default"] = Name;